import { isNil } from 'lodash';
import { useEffect, useState } from 'react';

export const secondsTohhmmss = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600),
    minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  let seconds = totalSeconds - hours * 3600 - minutes * 60,
    result = '';

  // round seconds
  seconds = Math.round(seconds * 100) / 100;

  if (hours > 0) {
    result += (hours < 10 ? '0' + hours : hours) + ':';
  }
  result += minutes < 10 ? '0' + minutes : minutes;
  result += ':' + (seconds < 10 ? '0' + seconds : seconds);
  return result;
};

export const dataURLtoBlob = (uri: string) => {
  const splitUri = uri.split(',');
  const split = splitUri[0];
  const match = split.match(/:(.*?);/);
  const mimeType: string | undefined = match ? match[1] : undefined;
  const decodedString = atob(splitUri[1]);
  let index = decodedString.length;
  const unsignedArray = new Uint8Array(index);
  while (index--) {
    unsignedArray[index] = decodedString.charCodeAt(index);
  }

  return new Blob([unsignedArray], { type: mimeType });
};

export const isEmpty = (value: number | undefined | null) => value === null || value === undefined;

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const handleResize = () => {
    setWindowDimensions(getWindowDimensions());
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return windowDimensions;
};

export const capStringAtNumChars = (stringToCheck: string | undefined, maxChars: number) => {
  if (!stringToCheck) {
    return;
  }
  const lengthOfString = stringToCheck.length;
  const maxMinusThree = maxChars - 3;
  if (lengthOfString > maxChars) {
    return stringToCheck.slice(0, maxMinusThree - 1) + '...';
  }
  return stringToCheck;
};

/**
 * Used to check if node is a span element
 * @param node - The node to check
 * @returns Boolean
 */
export const nodeIsSpanElement = (node: Element): boolean => {
  return node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'SPAN';
};

/**
 *  Check if a character is a space
 * @param char - The character to check
 * @returns Boolean
 */
export const isSpace = (char: string) => char === ' ';

/**
 * Check if value is missing. This includes null, undefined, and empty string.
 * @param value
 * @returns Boolean indicating if value is missing
 */
export const isMissing = (value: unknown): value is null | undefined | '' => {
  return isNil(value) || value === '';
};

/**
 * Get the last sequence of digits in a string.
 * @param str - The string to get the last number from.
 * @returns The last number in the string.
 * Example: getLastNumber('abc-123') -> 123
 */
export const getLastNumber = (str: string) => {
  const match = str.match(/\d+$/);
  return match ? parseInt(match[0], 10) : null;
};
